import { zip } from 'lodash'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import AnalyticsSample, { validateSampleField } from '@modules/admin/analytics/Analytics.SampleFilter'
import AccessControl from '@modules/auth/AccessControl'
import Loading from '@modules/core/components/Loading'
import AsyncProfessionalField from '@modules/formFields/AsyncProfessionalField'
import SelectAppRolesField from '@modules/formFields/SelectAppRolesField'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectSpecialityField from '@modules/formFields/SelectSpecialityField'
import moment from 'moment'
import React, { Component } from 'react'
import { Bar, Doughnut, Line } from 'react-chartjs-2'
import { Trans } from 'react-i18next'
import { Field, Form, reduxForm } from 'redux-form/dist/redux-form'
import Professional from '@services/Professional'
import ExportCsv from '../shared/ExportCsv'
import Title from '../shared/Title'
import {
  barResponseTimeParser,
  doughnutDataParser,
  labelsDoughnutPercentatge,
  lineDataParser,
  labelLineParseTime,
} from './utils'
import { PAAS_ADMIN, PROVIDER_ADMIN, SUPER_ADMIN } from '@constants/adminRoles'

class AnalyticsResponse extends Component {
  state = {
    firstResponseTimeChart: undefined,
    responseTimeChart: undefined,
    histogramFirstResponseChart: undefined,
    histogramResponseChart: undefined,
    doughnutResponse: undefined,
    doughnutFirstResponse: undefined,
  }

  client = Professional.analytics

  fetchResponseCharts = (values) => {
    const filters = {
      startDate:
        values.sample.startDate && moment(values.sample.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      endDate: values.sample.endDate && moment(values.sample.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      sampleRate: values.sample.sampleRate && values.sample.sampleRate,
      apiKeys: values.companyFilter.length ? values.companyFilter.map((co) => co.api_key).join(',') : undefined,
      specialityFilter:
        values.specialityFilter && values.specialityFilter.length
          ? values.specialityFilter.map((sp) => sp.id).join(',')
          : undefined,
      professionalFilter: values.professionalFilter && values.professionalFilter.hash,
      appRoleFilter: values.appRoleFilter,
    }

    return Promise.all([
      this.client
        .getResponseTimeChart(filters)
        .then((response) => this.setState({ responseTimeChart: response }))
        .catch((e) => {
          this.setState({ responseTimeChart: undefined })
          window.alert(JSON.stringify(e.message, null, 2))
        }),

      this.client
        .getFirstResponseTimeChart(filters)
        .then((response) => this.setState({ firstResponseTimeChart: response }))
        .catch((e) => {
          this.setState({ firstResponseTimeChart: undefined })
          window.alert(JSON.stringify(e.message, null, 2))
        }),

      this.client
        .getHistogramResponseChart(filters)
        .then((response) => this.setState({ histogramResponseChart: response }))
        .catch((e) => {
          this.setState({ histogramResponseChart: undefined })
          window.alert(JSON.stringify(e.message, null, 2))
        }),

      this.client
        .getHistogramFirstResponseChart(filters)
        .then((response) => this.setState({ histogramFirstResponseChart: response }))
        .catch((e) => {
          this.setState({ histogramFirstResponseChart: undefined })
          window.alert(JSON.stringify(e.message, null, 2))
        }),

      this.client
        .getDoughnutResponseChart(filters)
        .then((response) => this.setState({ doughnutResponse: response }))
        .catch((e) => {
          this.setState({ doughnutResponse: undefined })
          window.alert(JSON.stringify(e.message, null, 2))
        }),

      this.client
        .getDoughnutFirstResponseChart(filters)
        .then((response) => this.setState({ doughnutFirstResponse: response }))
        .catch((e) => {
          this.setState({ doughnutFirstResponse: undefined })
          window.alert(JSON.stringify(e.message, null, 2))
        }),
    ])
  }

  componentDidMount() {
    setTimeout(this.props.submit, 0)
  }

  render() {
    const { handleSubmit, submitting } = this.props
    const {
      responseTimeChart,
      firstResponseTimeChart,
      histogramResponseChart,
      histogramFirstResponseChart,
      doughnutResponse,
      doughnutFirstResponse,
    } = this.state
    const optionsDoughnut = {
      tooltips: {
        callbacks: {
          label: labelsDoughnutPercentatge,
        },
      },
    }
    const optionsLineTimeParse = {
      tooltips: {
        callbacks: {
          label: labelLineParseTime,
        },
      },
    }

    return (
      <div className="analytics-container">
        <DashboardHeader title={<Trans>Tiempos de respuesta</Trans>} />

        <Form className="container-filters-extended" onSubmit={handleSubmit(this.fetchResponseCharts)}>
          <div className="filter-extended">
            <Field name="sample" component={AnalyticsSample} validate={validateSampleField} />
            <AccessControl role="super-admin">
              <Field name="companyFilter" multi component={SelectCompanyField} />
            </AccessControl>
            <AccessControl roles={[SUPER_ADMIN, PAAS_ADMIN, PROVIDER_ADMIN]}>
              <Field name="appRoleFilter" component={SelectAppRolesField} simpleValue />
            </AccessControl>
            <Field name="specialityFilter" multi component={SelectSpecialityField} />
            <Field name="professionalFilter" component={AsyncProfessionalField} placeholder="Profesional" />
            {this.props.error && (
              <span style={{ color: 'red' }} className="error">
                {this.props.error}
              </span>
            )}
          </div>
          <div className="container-apply-filters">
            <button className="apply-filters" disabled={submitting}>
              <Trans>Aplicar filtros</Trans>
            </button>
          </div>
        </Form>

        <Loading isFetching={submitting} />

        {firstResponseTimeChart && (
          <div className="chart-container">
            <Title title={<Trans>Tiempos de primera respuesta</Trans>}>
              <ExportCsv
                data={zip(
                  firstResponseTimeChart.dates,
                  ...firstResponseTimeChart.datasets.map((dataset) => dataset.data)
                )}
                filename={'Tiempos_de_primera_respuesta.csv'}
                headers={['Fecha', ...firstResponseTimeChart.datasets.map((el) => el.label)]}
              />
            </Title>
            <Line data={lineDataParser(firstResponseTimeChart)} height={70} options={optionsLineTimeParse} />
          </div>
        )}

        {histogramFirstResponseChart && (
          <div className="chart-container">
            <Bar data={barResponseTimeParser(histogramFirstResponseChart)} height={70} />
          </div>
        )}

        {doughnutFirstResponse && (
          <div className="container-dognuts chart-container">
            <div className="dognut-box">
              <Doughnut data={doughnutDataParser(doughnutFirstResponse.twoMinutes)} options={optionsDoughnut} />
            </div>
            <div className="dognut-box">
              <Doughnut data={doughnutDataParser(doughnutFirstResponse.fourMinutes)} options={optionsDoughnut} />
            </div>
          </div>
        )}

        {responseTimeChart && (
          <div className="chart-container">
            <Title title={<Trans>Tiempos de respuesta</Trans>}>
              <ExportCsv
                data={zip(responseTimeChart.dates, ...responseTimeChart.datasets.map((dataset) => dataset.data))}
                filename={'Tiempos_de_respuesta.csv'}
                headers={['Fecha', ...responseTimeChart.datasets.map((el) => el.label)]}
              />
            </Title>
            <Line data={lineDataParser(responseTimeChart)} height={70} options={optionsLineTimeParse} />
          </div>
        )}
        {histogramResponseChart && (
          <div className="chart-container">
            <Bar data={barResponseTimeParser(histogramResponseChart)} height={70} />
          </div>
        )}

        {doughnutResponse && (
          <div className="container-dognuts chart-container">
            <div className="dognut-box">
              <Doughnut data={doughnutDataParser(doughnutResponse.twoMinutes)} options={optionsDoughnut} />
            </div>
            <div className="dognut-box">
              <Doughnut data={doughnutDataParser(doughnutResponse.fourMinutes)} options={optionsDoughnut} />
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default reduxForm({
  form: 'analytics',
  initialValues: {
    sample: {
      startDate: moment().startOf('week').toDate(),
      endDate: moment().toDate(),
      sampleRate: 'hour',
      id: 'custom',
    },
    companyFilter: [],
  },
  validate: (values) => ({ _error: validateSampleField(values.sample) }),
  destroyOnUnmount: false,
})(AnalyticsResponse)
